function onBridgeReady(data, cb) {
  let onBridgeReady = {
    "appId": data.appId,
    "timeStamp": data.timeStamp.toString(),
    "nonceStr": data.nonceStr,
    "package": data.packageStr,
    "signType": data.signType,
    "paySign": data.paySign
  }
  console.log('onBridgeReady', onBridgeReady )
    WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
            "appId": data.appId,
            "timeStamp": data.timeStamp.toString(),
            "nonceStr": data.nonceStr,
            "package": data.packageStr,
            "signType": data.signType,
            "paySign": data.paySign
        },
        function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
                cb('ok')
            } else if(res.err_msg == "get_brand_wcpay_request:cancel") {
                cb('cancel')
            }
            else {
                cb('fail', res)
            }
        }
    );
}

function callWXPay (data, cb) {
    console.log('callWXPay', data )
    if(typeof WeixinJSBridge == "undefined" || typeof WeixinJSBridge.invoke == "undefined") {

        if(document.addEventListener ) {

           document.addEventListener('WeixinJSBridgeReady', function() {
                onBridgeReady(data, cb)
           }, false);

        } else if(document.attachEvent) {

           document.attachEvent('WeixinJSBridgeReady', function() {
                onBridgeReady(data, cb)
           });

           document.attachEvent('onWeixinJSBridgeReady', function() {
                onBridgeReady(data, cb)
           });

        }
    } else {

       onBridgeReady(data, cb);

    }

}

module.exports = {
    callWXPay: callWXPay
}
